import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

export const FaceCautiousIcon: React.FC<IconProps> = ({ width = 32, height = 32, style }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="#FFB02E"
      />
      <path
        d="M10.4191 16.2244C12.742 16.2244 14.6251 14.3414 14.6251 12.0185C14.6251 9.69557 12.742 7.8125 10.4191 7.8125C8.09621 7.8125 6.21313 9.69557 6.21313 12.0185C6.21313 14.3414 8.09621 16.2244 10.4191 16.2244Z"
        fill="white"
      />
      <path
        d="M21.5683 16.3011C23.9123 16.3011 25.8126 14.4009 25.8126 12.0568C25.8126 9.71274 23.9123 7.8125 21.5683 7.8125C19.2242 7.8125 17.324 9.71274 17.324 12.0568C17.324 14.4009 19.2242 16.3011 21.5683 16.3011Z"
        fill="white"
      />
      <path
        d="M13 12C13 13.1046 12.1046 14 11 14C9.89543 14 9 13.1046 9 12C9 10.8954 9.89543 10 11 10C12.1046 10 13 10.8954 13 12Z"
        fill="#402A32"
      />
      <path
        d="M23 12C23 13.1046 22.1046 14 21 14C19.8954 14 19 13.1046 19 12C19 10.8954 19.8954 10 21 10C22.1046 10 23 10.8954 23 12Z"
        fill="#402A32"
      />
      <path
        d="M16 20C12.46 20 11.098 22.04 10.8944 22.4472C10.6474 22.9412 10.0467 23.1414 9.55276 22.8944C9.05878 22.6474 8.85856 22.0468 9.10555 21.5528C9.56861 20.6267 11.54 18 16 18C20.46 18 22.4313 20.6267 22.8944 21.5528C23.1414 22.0468 22.9412 22.6474 22.4472 22.8944C21.9532 23.1414 21.3525 22.9412 21.1055 22.4472C20.9019 22.04 19.54 20 16 20Z"
        fill="#402A32"
      />
    </svg>
  );
};
